import { FC } from 'react';
import cn from 'classnames';
import {
	Menu,
	MenuButton,
	MenuItem as MenuItemInner,
	MenuItemProps,
	SubMenu as SubMenuInner,
	SubMenuProps,
} from '@szhsin/react-menu';
// import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/zoom.css';
import '@szhsin/react-menu/dist/core.css';

import st from './DropdownBtn.module.scss';

/** Компонента-Пункт меню с предустановленными классами */
export const MenuItem: FC<MenuItemProps> = (props) => {
	return (
		<MenuItemInner
			{...props}
			className={cn(st.menuItem, props.className)}
		/>
	);
};

/** Компонента-Подменю с предустановленными классами */
export const SubMenu: FC<SubMenuProps> = (props) => {
	return (
		<SubMenuInner
			{...props}
			menuClassName={`${st.contextMnu} ${st.subMenus}`}
			itemProps={{ className: st.menuItem }}
		/>
	);
};

export { Menu, MenuButton };
